import { createContext, useContext } from 'react';

interface HubEditorContextValue {
	mediaConfig?: {
		asapIssuer: string;
		mediaCollectionName: string;
		mediaToken: string;
		mediaUrl: string;
	};
}

export const HubEditorContext = createContext<HubEditorContextValue>({});

export const useHubEditorContext = () => {
	const context = useContext(HubEditorContext);
	if (!context) {
		throw new Error('useHubEditorContext must be used within a HubEditorContextProvider');
	}
	return context;
};